import React from 'react'
import Modal from "react-bootstrap/Modal"
import Button from "react-bootstrap/Button"
import {Form, FormSelect} from "react-bootstrap"
import {getCardDetailsFromDOM, getFieldDatesForAddUpdateCardBank, oldValues} from "../functions"

export class ModalUpdateCardBankClass extends React.Component {

    render() {

        const {lang, updateCardHandler, closeHandler, data} = this.props

        const changeNameHandler = (e) => {
            if (e.target.value !== '0') {
                e.target.classList.remove('is-invalid')
            } else {
                e.target.classList.add('is-invalid')
            }
        }

        const changeTypeHandler = (e) => {
            const type = e.target.value
            switch (type) {
                case 'Debit':
                    document.querySelector('#div-selector-date').classList.add('d-none')
                    break
                case 'Credit':
                    document.querySelector('#div-selector-date').classList.remove('d-none')
                    break
                default:
                    document.querySelector('#div-selector-date').classList.add('d-none')
            }
        }

        getFieldDatesForAddUpdateCardBank(lang, data)

        return (
            <>
                <Modal id={"create-modal"} show={true}>
                    <Modal.Header>
                        <Modal.Title className={'w-100 text-center'}>{data.title}</Modal.Title>
                        <Button className={'ms-2'} variant={"close"} onClick={closeHandler}/>
                    </Modal.Header>
                    <Modal.Body id={'modal-body'}>
                        <Form className={'was-validated'}>
                            <div className={'ms-3 me-3'}>
                                <p className={'text-start'}>{lang.body.cardBankPage.descUpdate}</p>
                            </div>
                            <fieldset className={'teal p-3'}>
                                <div id={"divNameCard"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.labelName}
                                    </label>
                                    <input
                                        type={"text"}
                                        name={"nameCard"}
                                        id={"nameCard"}
                                        className={"form-control is-invalid"}
                                        onChange={changeNameHandler}
                                        required={true}
                                        defaultValue={data.contentName}
                                        placeholder={lang.body.cardBankPage.placeholderName}
                                    />
                                </div>
                                <div id={"divType"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.labelType}
                                    </label>
                                    <FormSelect id={'select-type'}
                                                required={true}
                                                defaultValue={oldValues(lang, data).type}
                                                className={'is-invalid'}
                                                onChange={changeTypeHandler}>
                                        <option value={''}>{lang.body.cardBankPage.labelType}</option>
                                        <option
                                            value={"Credit"}>{lang.body.cardBankPage.textTypeCreditCard}</option>
                                        <option value={"Debit"}>{lang.body.cardBankPage.textTypeDebitCard}</option>
                                    </FormSelect>
                                </div>
                                <div id={"divCurrency"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.cardBankPage.selectCurrencyLabel}
                                    </label>
                                    <FormSelect id={'select-currency'}
                                                required={true}
                                                defaultValue={oldValues(lang, data).currency}
                                                className={'is-invalid'}>
                                        <option value={''}>{lang.body.cardBankPage.currency}</option>
                                        <option value={"USD"}>{lang.body.cardBankPage.usd}</option>
                                        <option value={"ILS"}>{lang.body.cardBankPage.ils}</option>
                                        <option value={"EUR"}>{lang.body.cardBankPage.eur}</option>
                                        <option value={"RUB"}>{lang.body.cardBankPage.rub}</option>
                                    </FormSelect>
                                </div>
                                <div id={"divDefault"} className={"mb-4"}>
                                    <label className={"form-label"}>
                                        {lang.body.moneyPage.isNewUser.setDefault}
                                    </label>
                                    <input id={'input-default'}
                                           type={'checkbox'}
                                           defaultChecked={data.contentDefault}
                                           required={false}
                                           className={'form-check-input is-invalid ms-3'}>
                                    </input>
                                </div>
                            </fieldset>
                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button disabled={false}
                                variant={data.btnOKColor}
                                onClick={() => {
                                    updateCardHandler(getCardDetailsFromDOM())
                                }}>
                            {data.btnOK}
                        </Button>
                        <Button
                            variant={data.btnCancelColor}
                            onClick={closeHandler}>
                            {data.btnCancel}
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        )
    }
}